// import TagManager from "react-gtm-module";
import React, {useContext, useEffect, useState} from 'react';
import { useT } from '../../helpers/i18n';
import Redis from 'ioredis'
import MobileDetect from 'mobile-detect';
import dynamic from 'next/dynamic';

import * as appContext from '../../components/AppContext';
import BottomSections from '../../components/BottomSections';
import Contact from '../../components/Contact';
import BuilderHead from '../../components/head/BuilderHead';
import Header from '../../components/Header';
import { InlineStyles } from '../../components/templates/index/partials/InlineStyles';
import Checkers from '../../helpers/class/Checkers';
import * as DataFetchHelper from '../../helpers/DataFetchHelper';
import { fetContactDetails } from '../../helpers/DataFetchHelper';
import * as MethodHelper from '../../helpers/MethodHelper';
import { setPageId } from '../../redux/actions';
import { wrapper } from '../../redux/store';
import GoogleMapSection from "../../components/GoogleMapSection";
import MainLayout from "../../layouts/MainLayout";
import {redis} from "../../redis";
import PartnersSection from "../../components/templates/index/sections/PartnersSection";
import { ElfsightWidget } from "react-elfsight-widget";

const Scripts = dynamic( () => import( '../../components/Scripts' ), { ssr: false });

export default function Home ( props ) {
  const t = useT();

  const pageContext = useContext( appContext.page );
  pageContext.pageId = props.app_data.page_id;

  pageContext.isMobile = props.isMobile;
  pageContext.isTablet = props.isTablet;
  pageContext.isDesktop = props.isDesktop;

  pageContext.appSettings = props.app;
  const app = props.app;
  const builder = app.builder;

  const contactSeo = {
    seoUrl: builder.builder_contact_seo_title_cat,
    seoMetaTitle: builder.builder_contact_seo_meta_title_cat,
    seoMetaDescription: builder.builder_contact_seo_desc,
    seoMetaKeywords: builder.builder_contact_seo_keywords
  }

  contactSeo.seoMetaKeywords = contactSeo.seoMetaKeywords &&  contactSeo.seoMetaKeywords.split("__TAG__").join(", ");

  const [ urlHref, setUrlHref ] = useState( null );
  React.useEffect( () => {
    if ( window !== undefined ) {
      setUrlHref( window.location.href );
    }
  }, [urlHref]);

  const domain = props.domain;
  const head = props.head;
  const footer = props.footer;

  const app_data = props.app_data;
  const locations = props.locations;
  const navigation = props.navigation;
  const content = props.content;
  const propertyMapData = props.propertyMapData;
  const contactHtml = props.contactHtml;
  const rgbDesignColor = props.rgbDesignColor;
  const rgbSearchbarColor = props.rgbSearchbarColor;
  const html_sections = props.html_sections;
  const script_sections = props.script_sections;
  const contact_sections = props.contact_sections;``

  const isDesktop = props.isDesktop;

  const image_fb_meta = Checkers.isValidArray( head.og_image ) ? head.og_image[0].image : null;

  const contactIcons = {
    phoneIcon: app.showPhoneIconOnMenu,
    chatIcon: app.showChatIconOnMenu,
    mailIcon: app.showMailIconOnMenu,
    phoneIconData: app.menuPhoneIconData,
    chatIconData: app.menuChatIconData,
    mailIconData: app.menuMailIconData
  }

  const mapEnabled = builder.builder_properties_map;

  const showContactMap = mapEnabled == "1" ? app.showContactMap : false

  const googleMapShow = app.viewMap

  const googleMapApiKey = app.googleMapsApiKey;

  const hqLatitude = app.headQuarterLatitude != undefined ? app.headQuarterLatitude : null

  const hqLongitude = app.headQuarterLongitude != undefined ? app.headQuarterLongitude : null

  const sections = props.contact_sections?.contact_sections ?? [];

  const beforeContact = sections.find(
    section => section.app_section_position === "before_contact"
  );

  const afterContact = sections.find(
    section => section.app_section_position === "after_contact"
  );

  const htmlSectionsArr = html_sections != null && html_sections.hasOwnProperty( 'app_sections' ) ? html_sections.app_sections : null;

  return (
      <MainLayout {...props}>
        {/*<InlineStyles app={app} rgbDesignColor={rgbDesignColor} rgbSearchbarColor={rgbSearchbarColor}/>*/}
        <BuilderHead
          title={contactSeo.seoMetaTitle == '' ? head.data.title + ' - ' + head.data.motto + ' | ' + t('common.home') + ' ' : contactSeo.seoMetaTitle }
          keywords={contactSeo?.seoMetaKeywords?.length == 0 ? head.data.meta_keywords : contactSeo.seoMetaKeywords }
          titleOfficial={head.data.titleOfficial}
          domain={urlHref}
          icon_60={head.data.icon_60}
          icon_76={head.data.icon_76}
          icon_120={head.data.icon_120}
          icon_152={head.data.icon_152}
          icon_256={head.data.icon_256}
          icon={head.data.icon}
          seoUrl={contactSeo.seoUrl ? props.domain + '/' + contactSeo.seoUrl : null}
          title_fb_meta={ contactSeo.seoMetaTitle == '' ?
            head.data.title +
            ' - ' +
            head.data.motto 
            : contactSeo.seoMetaTitle }
          desc_fb_meta={contactSeo.seoMetaDescription == '' ? head.data.meta_description : contactSeo.seoMetaDescription }
          image_fb_meta={image_fb_meta}
          site_name_fb_meta={head.data.title}
          lat_fb_meta={head.location.latitude}
          lon_fb_meta={head.location.longitude}
          twitter_img_alt={head.data.title + ' - ' + head.data.motto + head.data.meta_description && '. ' + head.data.meta_description}
          googleSchemaContext={domain}
          googleSchemaTitle={head.data.title}
          googleSchemaStreetAddress={head.location.address}
          googleSchemaCity={head.location.city}
          googleSchemaCountry={head.location.country}
          googleSchemaZip={head.location.zip}
          googleSchemaPhone={head.location.phone}
          designColor={app.designColor}
          font={app.font}
          manager={false}
        />
        {/*<Header*/}
        {/*  app={app}*/}
        {/*  builder={builder}*/}
        {/*  phone={head.location[0].phone}*/}
        {/*  menu={navigation.menu}*/}
        {/*  partials={navigation.partials}*/}
        {/*  showBookButtonMenu={app.showBookButtonMenu}*/}
        {/*  contactIcons={app.showContactIconsOnMenu ? contactIcons : null}*/}
        {/*  pageTitle={head.data.title}*/}
        {/*  property={true}*/}
        {/*/>*/}

        {
          showContactMap && hqLatitude != null && hqLongitude ?
              <GoogleMapSection
                  app={props.app}
                  googleMapApiKey={googleMapApiKey}
                  googleMapShow={googleMapShow}
                  property_lat={propertyMapData?.location?.latitude ?? hqLatitude}
                  property_lng={propertyMapData?.location?.longitude ?? hqLongitude}
                  map_pois={propertyMapData?.map_pois ?? []}
                  descAreaDistances={propertyMapData?.descAreaDistances}
                  propertyTitle={propertyMapData?.propertyTitle}
                  propertyImages={propertyMapData?.propertyImages ?? []}
                  propertyAddress={propertyMapData?.location}
                  container={'container-fluid'}
              />
              :
              <></>
        }
        {
          htmlSectionsArr != null && Checkers.isValidArray( htmlSectionsArr ) ?
            <div className={'container-fluid overflow-hidden' + ( !app_data?.is_manager ? ' pb-4' : '' )}>
              {
                MethodHelper.uniqueElfsightSections( htmlSectionsArr ).map( ( section, key ) => (
                  section.app_section_content != null ?
                    section.app_section_content.includes( 'elfsight-app' ) ?
                      section.app_section_content.split( 'elfsight-app-' )[1] != null ?
                        <ElfsightWidget key={key}
                          widgetID={section.app_section_content.split( 'elfsight-app-' )[1].split( '"></div>' )[0]} />
                        :
                        <></>
                      :
                      <></>
                    :
                    <></>
                ))
              }
            </div>
            :
            <></>
        }
        {!app_data?.is_manager && <PartnersSection content={content}/>}
       <div
          className="container-fluid m-0 p-0"
          style={{ backgroundColor: "white" }}
          dangerouslySetInnerHTML={{
            __html: beforeContact?.app_section_content || "",
          }}
        />
        <Contact
          isDesktop={isDesktop}
          contactFormTitle={app.contactFormTitle}
          locations={locations != null ? locations.hasOwnProperty( 'page_locations' ) ? locations.page_locations : null : null}
          captchaSiteKey="6Ldn5jYUAAAAAHV8v0apDoa8Hd1O67fo92WqpWRY"
          contactPhoneOverride={app.builder.builder_contact_page_phone}
          contactEmailOverride={app.builder.builder_contact_page_email}
          // contactTitleOverride={app.builder.builder_contact_page_title}
          showContactSection={true}
          showContactForm={app.showContactForm}
          searchbarRadius={app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius.length : null : null}
          contactHtml={contactHtml}
          contact_sections={contact_sections}
          isManager={app_data.is_manager}
          socialLinks={content?.socialLinks}
          managerContact={content?.managerContact}
          propertyLat={content?.details?.lat}
          propertyLng={content?.details?.lng}
          propertyBadges={content?.propertyBadges}
          contactTitleOverride={
                Checkers.isValidString(app.builder.builder_contact_page_title)
                  ? app.builder.builder_contact_page_title
                  : ( !props.app_data?.is_manager && Checkers.isValidString( props.content?.details?.title ) ? props.content.details.title : null )
              }
        />

        {/*<BottomSections*/}
        {/*  isDesktop={isDesktop}*/}
        {/*  contactSection={false}*/}
        {/*  footerSection={true}*/}
        {/*  app_data={app_data}*/}
        {/*  app={app}*/}
        {/*  head={head}*/}
        {/*  locations={locations}*/}
        {/*  footer={footer}*/}
        {/*  htmlSections={props.html_sections}*/}
        {/*/>*/}
        {/*<Scripts/>*/}
      </MainLayout>
  )
}



// export async function getServerSideProps ({ req, res }) {
export const getServerSideProps = wrapper.getServerSideProps( ( store ) => async (
  { req,
    res,
    query
  }) => {

  const [ isMobile, isTablet,  isDesktop ] = Checkers.getUserAgentData( store, req )

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  let subdomain = null;
  const slug_data = null;

  let head = null;
  let app = null;
  let page = null;
  let app_data = null;
  let navigation = null;
  let content = null;
  let html_sections = null;
  let script_sections = null;
  let locations = null;
  let footer = null;
  let rgbSearchbarColor = null;
  let rgbDesignColor = null;
  let contactHtml = null
  let contact_sections = null;

  let manifest = null;

  const domain = req.headers.host;
  const hostname_parts = req.headers.host.split( '.' );
  const parts = hostname_parts.length;

  app_data = await DataFetchHelper.fetchAppData( req, redis, res );
  if ( app_data==false ) {
    return {
      notFound: true,
    }
  }

  store.dispatch( setPageId( app_data.page_id ) )

  await DataFetchHelper.fetchSystemData( redis, app_data.page_id, store ).then( ( response ) => {
    head = response.head
    app = response.app
    page = response.page
    navigation = response.navigation
    locations = response.locations
    footer = response.footer
    html_sections = response.html_sections
    contactHtml = response.contactHtml
    contact_sections = response.contact_sections
  })

  content = await DataFetchHelper.fetchContentData( redis, app_data.page_id )

  let propertyMapData = null
  if ( content?.property_id && content?.is_chain == false ) {
    const propertyContent = await DataFetchHelper.fetchPropertyContent( redis, app_data.page_id, content.property_id, store )
    propertyMapData = {
      location: propertyContent.location,
      map_pois: propertyContent.map_pois,
      descAreaDistances: propertyContent.details?.desc_area_distances,
      propertyTitle: propertyContent.details?.property_title,
      propertyImages: Checkers.isValidArray( propertyContent.album ) ? propertyContent.album.map( ( image ) => image.image_thumb || image.image ) : [],
    }
  }

  manifest = MethodHelper.initManifest( head, app, '/?source=pwa' );
  manifest = MethodHelper.extendManifest( manifest, head );

  const json = JSON.stringify( manifest );
  const fs = require( 'fs' );
  fs.writeFile( './public/manifest.json', json, ( err ) => {
    if ( err ) {
      

    // eslint-disable-next-line no-console
      console.error( err )
      return
    }
  });

  if ( app.searchbarBgColor != null )
    rgbSearchbarColor = MethodHelper.hexToRgb( app.searchbarBgColor );
  if ( app.designColor )
    rgbDesignColor = MethodHelper.hexToRgb( app.designColor );

  

  return {
    props: {
      app_data: app_data,
      head: head,
      page: page,
      builder: app != null && app.builder != null ? app.builder : null,
      app: app,
      navigation: navigation,
      content: content,
      propertyMapData: propertyMapData,
      html_sections: html_sections,
      script_sections: script_sections,
      locations: locations,
      footer: footer,
      contact_sections: contact_sections,
      domain: domain,
      subdomain: subdomain,
      parts: parts,
      slug_data: slug_data,
      rgbDesignColor: rgbDesignColor,
      rgbSearchbarColor: rgbSearchbarColor,
      isDesktop: isDesktop,
      contactHtml: contactHtml
    }
  }
})
